import { IconBell, IconRadio, IconChartBar, IconCreditCard, IconDeviceTv, IconFolders, IconLanguage, IconLayoutDashboard, IconMovie, IconPhoto, IconRating18Plus, IconSettings, IconTags, IconUserCog, IconUsersGroup, IconVideo, IconWallet, type TablerIcon } from '@tabler/icons-react';
import { PERMISSIONS } from '@/config/constants';

export interface NavItem {
  label: string;
  path: string;
  icon: TablerIcon;
  permission?: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAVIGATION: NavGroup[] = [
  {
    label: 'Overview',
    items: [{ label: 'Dashboard', path: '/', icon: IconLayoutDashboard }],
  },
  {
    label: 'Content',
    items: [
      { label: 'Movies', path: '/movies', icon: IconMovie, permission: PERMISSIONS.MOVIES_VIEW },
      { label: 'Series', path: '/series', icon: IconDeviceTv, permission: PERMISSIONS.SERIES_VIEW },
      { label: 'Live TV', path: '/live-tv', icon: IconRadio },
      { label: 'Adult Providers', path: '/adult-providers', icon: IconRating18Plus, permission: PERMISSIONS.MOVIES_MANAGE },
      { label: 'Banners', path: '/banners', icon: IconPhoto, permission: PERMISSIONS.BANNERS_MANAGE },
    ],
  },
  {
    label: 'Taxonomy',
    items: [
      { label: 'Genres', path: '/taxonomy/genres', icon: IconTags, permission: PERMISSIONS.TAXONOMY_MANAGE },
      { label: 'Categories', path: '/taxonomy/categories', icon: IconFolders, permission: PERMISSIONS.TAXONOMY_MANAGE },
      { label: 'Languages', path: '/taxonomy/languages', icon: IconLanguage, permission: PERMISSIONS.TAXONOMY_MANAGE },
      { label: 'Studios', path: '/taxonomy/studios', icon: IconVideo, permission: PERMISSIONS.TAXONOMY_MANAGE },
      { label: 'Actors', path: '/taxonomy/actors', icon: IconUsersGroup, permission: PERMISSIONS.TAXONOMY_MANAGE },
      { label: 'Live TV Categories', path: '/taxonomy/live-tv-categories', icon: IconRadio, permission: PERMISSIONS.TAXONOMY_MANAGE },
    ],
  },
  {
    label: 'People',
    items: [{ label: 'Users', path: '/users', icon: IconUserCog, permission: PERMISSIONS.USERS_VIEW }],
  },
  {
    label: 'Commerce',
    items: [
      { label: 'Subscriptions', path: '/subscriptions', icon: IconCreditCard, permission: PERMISSIONS.SUBSCRIPTIONS_VIEW },
      { label: 'Plans', path: '/plans', icon: IconWallet, permission: PERMISSIONS.PLANS_VIEW },
    ],
  },
  {
    label: 'Engagement',
    items: [
      { label: 'Analytics', path: '/analytics', icon: IconChartBar, permission: PERMISSIONS.REPORTS_VIEW },
      { label: 'Notifications', path: '/notifications', icon: IconBell, permission: PERMISSIONS.NOTIFICATIONS_MANAGE },
    ],
  },
  {
    label: 'System',
    items: [{ label: 'Settings', path: '/settings', icon: IconSettings, permission: PERMISSIONS.SETTINGS_MANAGE }],
  },
];
